<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Predict Models</p>
      <button class="delete" @click="$emit('close')"></button>
    </header>

    <div class="modal-card-body">
      <div class="is-size-5">Models list</div>

      <p v-if="!Object.keys(data).length">No models available in this group.</p>

      <div class="select is-normal">
        <select v-model="selected_model">
          <option v-for="(value,key) in data" :key="key" :value="value">{{key}}</option>
        </select>
      </div>
    </div>
    <div class="modal-card-foot" style="justify-content: end">
      <button class="button" @click="$emit('close')">
        Cancel
      </button>
      <button 
      :class='{"is-loading":is_loading}'
      
      @click="predict" class="button is-info">
        Predict
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import APIService from "@/services/api.service";

export default {
  data() {
    return {
      is_loading: false,
      data: null,
      selected_model:"",
      apiService: new APIService(),
    };
  },
  computed: {
    ...mapState([
      "draw",
      "claims",
      "active_project",
    ]),
  },
  created() {
    this.apiService
      .get_models_list({
        query: `project_uid=${this.active_project.projectUid}&no_token`,
      })
      .then((res) => {
        this.data = res.data || {};
        console.log(res);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods:{
    predict(){
      this.is_loading = true
      if(!this.selected_model){
        alert("No model selected.")
      this.is_loading = false;

          return; 
      }


      if((!this.active_project ||
      !this.active_project.reports ||
      !this.active_project.reports.ortho ||
      !this.active_project.reports.ortho.url)
      ) {
          alert("Ortho not present.")
      this.is_loading = false;

          return;
      }

      const body = {
        geojson: this.draw.getAll(),
        data: {
          ortho: this.active_project.reports.ortho.url,
          ml_models:this.selected_model
        },
        details: {
          project_uid: this.active_project.projectUid,
          user_email: this.claims.email,
        },
      };
      this.clicks_loading = true
      this.apiService
      .scm_predict({
       body
      })
      .then((res) => {
        this.$toast.open({
            message: res.data.description || "Successfully queued training.",
            type: "is-success",
          });
          this.$emit('close');
      this.is_loading = false

      })
      .catch((err) => {
        console.log(err);
      this.is_loading = false

      });
    }
  }
};
</script>
